import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { Page } from '@gestor-web/app/shared/components';
import { map } from 'rxjs/operators';
import { RpsPrestadoresRegistradosFilterData } from './components/filtro/filtro.component';

@Injectable()
export class RpsPrestadoresRegistradosService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  fetchData(regans: string, filtros: RpsPrestadoresRegistradosFilterData, pageData: Page) {
    return this.simuladorGoApi
      .fetchRpsPrestadoresRegistrados({
        regans,
        id_classificacao: filtros.idClassificacao,
        sn_urgencia_emergencia: filtros.snUrgenciaEmergencia,
        tp_relacao_operadora: filtros.tpRelacaoOperadora,
        tp_contratualizacao: filtros.tpContratualizacao,
        nr_cpf_cnpj: filtros.nrCpfCnpj,
        nr_cnes: filtros.nrCnes,
        nr_registro_plano: filtros.nrRegistroPlano,
        page: pageData.page,
        size: pageData.size,
      })
      .pipe(map(data => ({ items: data.items ?? [], total: data.total ?? 0 })));
  }
}
